import axios from "axios";
import { Ziggy } from "../ziggy";
import { queryOptions } from "@tanstack/react-query";

const { routes } = Ziggy;
/**
 * Creates a query options object for fetching users, intended for use with React Query.
 *
 * @param {Object} params - The parameters used for filtering, pagination, or search.
 * @param {QueryOptions} [options] - Optional additional query options (e.g., staleTime, enabled).
 * @returns {import('@tanstack/react-query').QueryOptions} A React Query options object configured for fetching users.
 */
export default function createReportedUsersQueryOptions(params, options) {
  return queryOptions({
    queryKey: ["users", "reported-users", params],
    queryFn: () => getReportedUsers(params),
    ...options,
  });
}

const getReportedUsers = async (params = {}) => {
  const response = await axios.get(routes.reportedUsers.uri, { params });
  return response.data;
};
